import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import {
  AuthService,
  FacebookLoginProvider,
  GoogleLoginProvider
} from '../../../../assets/angular5-social-login';
import { GoogleService } from '../../../shared/Google.service';
// import { LOGIN_MUTATION_QUERY } from '../../../shared/models/query';
import { Http, Response, RequestOptions, Headers, RequestOptionsArgs } from '@angular/http';
import { HttpHeaders } from '@angular/common/http';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Constants } from '../../../shared/models/constants';
import { PouchdbService } from '../../../shared/pouchDb.service';
import { IS_ElectronService } from '../../../shared/IS_Electron.service';
import { LanguageTranslateObservableService } from '../../../shared/languageTranslateObservable.service';
import { LoginObservableService } from "../../../shared/loginObservable.service";
import { MatSnackBar } from '@angular/material';
import { ShelfPouchDb } from '../../shelf.pouchdb.service';
import { Component_interactionService } from '../../../component_interaction.service';
declare var gapi: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})


export class LoginComponent implements OnInit {

  @Input() data: any;
  @Output() loginCallback: EventEmitter<any> = new EventEmitter<string>();
  userCredentials = [{ name: 'Manage Account' }, { name: 'Language', 'sub': ['English', 'Arabic', 'Telugu', 'Tamil', 'Malayalam', 'Hindi'] }];
  user;

  constructor(private shelfpouch: ShelfPouchDb, private socialAuthService: AuthService, private GoogleService: GoogleService, private http: Http, public dialog: MatDialog, private PouchdbService: PouchdbService, private ElectronService: IS_ElectronService, private translateService: LanguageTranslateObservableService, private LoginObservableService: LoginObservableService, public snackBar: MatSnackBar,private Component_interactionService:Component_interactionService) { }
  color = '#0085fe';
  selectOptionInd = undefined;
  firstToggle;
  displayChild = false;
  userGoogleDriveId;
  selectedLanguageIndex;

  ngOnInit() {
    if (this.data && this.data.popupProps.curComp.isLoggedIn) {
      this.user = this.data.popupProps.curComp.loginUserDetails;
    }

    if (this.ElectronService.IS_ELECTRON) {
      this.userCredentials[0].name = 'Redeem';
    }
    if (localStorage.selectedLanguageInd == undefined) localStorage.selectedLanguageInd = 0


      this.selectedLanguageIndex = Number(localStorage.selectedLanguageInd);
  }


  startReplicationTo() {


    this.shelfpouch.startReplicationTo();
  }
  updateSlide(ev) {

    var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable('Show_Recent');
    if (isFeatureAvailable == 'false') {
      //  this.openSnackBar("This Feature is Not Enabled", '');
      this.data.popupProps.showPopup = false;
      this.LoginObservableService.openSubscribenowPopup();
      this.data.popupProps.curComp.displayRecents = false;

      return;
    }

    this.data.popupProps.curComp.displayRecents = ev.checked;

    this.data.popupProps.showPopup = true;

    localStorage.isCheckedRecents = ev.checked
  }



  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      panelClass: ['snack-bar-color'],
      duration: 2000,
    });
  }


  public socialSignIn(socialPlatform: string) {

    let socialPlatformProvider;
    if (socialPlatform == "facebook") {
      socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
    } else if (socialPlatform == "google") {
      socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
    }
    this.socialAuthService.signIn(socialPlatformProvider).then(
      (userData) => {
        this.user = userData;
        localStorage.userData = JSON.stringify(userData);

        if (this.data) {
          this.data.popupProps.curComp.isLoggedIn = true;
          this.data.popupProps.showPopup = false;
          this.data.popupProps.curComp.userdata(userData);
        } else {
          this.loginCallback.emit({
            isLoggedIn: true,
            userData: userData
          })
        }



        gapi.load('client', {
          callback: function () {
          },
          onerror: function () {
          },
          timeout: 5000, // 5 seconds.
          ontimeout: function () {
          }
        });

        gapi.client.load('drive', 'v2', function () { });
        gapi.client.load('people', 'v1', function () { });
        var self = this

        this.isNooorFolder();

        var temp;

        if (localStorage.nasResponse) {
          temp = JSON.parse(localStorage.nasResponse);
        }

        if (temp && temp.signIn != null && temp.signIn != undefined && temp.signIn.user.email != userData.email) {
          this.isRedeemedMapped(temp, '');
        }
        else {
          this.getUserIdAndOrganizationId(userData, '');
        }


      });
  }


  selectUserOption(name, ev) {

    ev.stopPropagation();
    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + localStorage.userToken);

    const options = new RequestOptions({ headers: headers });
    this.displayChild = true;


    if (name == 'Manage Account' || name == 'Redeem') {
      this.data.popupProps.showPopup = false;
      let dialogRef = this.dialog.open(enterRedeem, {
        width: '400px',
        data: options,
        disableClose: false
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined) {
          this.getUserIdAndOrganizationId(this.user, '');
        }
      });
    }
  }


  public socialSignOut(ev) {
    // ev.stopPropagation();
    this.socialAuthService.signOut();
    this.user = {};
    this.data.popupProps.curComp.isLoggedIn = false;
    this.data.popupProps.showPopup = false;
    localStorage.userData = undefined;
    this.PouchdbService.destroyPouchDb();
    localStorage.clear();
    localStorage.appServer = 'Dev';
    this.data.popupProps.curComp.logOut();
    if (this.ElectronService.IS_ELECTRON) {
      this.ElectronService.clearUserData();
    }
  }

  getUserIdAndOrganizationId(info, state) {
    
     var self = this;
     this.Component_interactionService.connectingToNAS_Server(info).then(function(data){
      self.isRedeemedMapped(data, state)
     })

  }

  isRedeemedMapped(data, state) {

    if(data.signIn == null){
      alert('not properly login ........ NAS responce Null');
      this.socialSignOut('');
      return
    }

    if (this.ElectronService.IS_ELECTRON) {
      this.ElectronService.createUserIdFolder(data.signIn.organizationId+'_'+data.signIn.user.id);
    }

    // console.log(data.signIn.token);
     localStorage.userToken = data.signIn.token;

    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + data.signIn.token);

    const options = new RequestOptions({ headers: headers });
    if (!data.signIn.user.isRedeemedMapped && data.signIn.organizationId == '') {
      let newRedeem = 'abc1-3485c523-3c88-4d92-950b-bec0c5e787a5';
      if (this.data) {
        this.data.popupProps.showPopup = false;
      }

      let dialogRef = this.dialog.open(enterRedeem, {
        width: '400px',
        data: options,
        disableClose: false
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined) {
          this.getUserIdAndOrganizationId(this.user, 'firstuser');
        }
      });
    }

    else {
       document.getElementsByClassName('showApploader')[0].classList.add('hideApploader');
       var self = this;
      this.Component_interactionService.connectingToLCS_Server(data,state).then(function(res){
        self.PouchdbService.connnectToPouchDB(res, state);
      })
    }
  }


  isNooorFolder() {

    if (gapi.client.drive) {
      this.GoogleService.getmyfile(Constants.nooorFolderId).then(
        (val) => {

          if (!val) {
            this.GoogleService.CreateNooorfolder('Nooor');
          }
          else {
            localStorage.currentDriveId = val;
            this.isNoorMediaFOlder(val);
          }
        }
      );
    }
    else {
      var self = this;
      setTimeout(function () {
        self.isNooorFolder();
      }, 500);
    }
  }
  isNoorMediaFOlder(noorDriveId) {
    this.GoogleService.getmyfile(Constants.nooorMediaFolderId).then(
      (val) => {

        if (!val) {
          this.GoogleService.CreateMediafolder('Media', noorDriveId);
        }
        else {
          localStorage.currentDriveMediaId = val;
        }
      }
    );
  }

  updateCreateFolderID(id) {
    localStorage.currentDriveMediaId = id;
  }

  changeLangage(list: any, j) {
    localStorage.selectedLanguageInd = j;
    if (j == 0 || j == 1) {

      this.translateService.languageChanged(list)
    }
    else {
      return
    }
  }
}


@Component({
  selector: 'app-redeem',
  templateUrl: './redeem.popup.html',
  styleUrls: ['./login.component.css']
})
export class enterRedeem {

  public newRedeemValue;
  public showErrMsg = false;
  public showSuccMsg = false;
  public errInformation;
  public succInformation = "Redeem Successfully Mapped";
  constructor(
    public dialogRef: MatDialogRef<enterRedeem>,
    @Inject(MAT_DIALOG_DATA) public data: any, private http: Http) { }

  closeRedeem(): void {
    this.dialogRef.close();
  }

  addRedeem() {
    if (this.newRedeemValue == '') {
      this.showErrMsg = true;
      this.errInformation = '* please enter redeem value';
    } else {
      this.showErrMsg = false;
      var options = this.data;
      var self = this;
      this.http.post(
        "http://" + Constants.nasUrl, {
          "query": 'mutation validateRedeem($redeemCode: String!, $uuid: String, $ip: String) { ValidateRedeem(redeemCode: $redeemCode, uuid: $uuid, ip: $ip)} ',
          variables: {
            "redeemCode": this.newRedeemValue,
            "uuid": "",
            "ip": "",
          }
        },
        options
      ).subscribe(
        res => self.redeemUpdated(res.json().data)
        );
    }
  }

  redeemUpdated(data) {
    if (data.ValidateRedeem == "User Linked") {
      this.showErrMsg = false;
      this.showSuccMsg = true;
      var self = this;
      setTimeout(function () {
        self.dialogRef.close(true);
      }, 1000);

    } else {
      this.errInformation = '* redeem is already used';
      this.showErrMsg = true;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/shelf/popups/login/login.component.ts